import { internalLinkPath } from "@/constants/index"
import { getPureText } from "@/utils/helper"

export const checkSingleNonEmptyLevelThreeNavMulti = data => {
  let nonEmptyLevelThreeNavMultiIndex = -1
  let nonEmptyLevelThreeNavMultiCount = 0

  for (let i = 0; i < data.length; i++) {
    for (const levelTwoNavMulti of data[i].levelTwoNavMulti) {
      if (levelTwoNavMulti.levelThreeNavMulti.length >= 1) {
        nonEmptyLevelThreeNavMultiCount++
        if (nonEmptyLevelThreeNavMultiCount > 1) {
          return -1 // More than one non-empty levelThreeNavMulti found
        } else {
          nonEmptyLevelThreeNavMultiIndex = i
        }
      }
    }
  }
  return nonEmptyLevelThreeNavMultiIndex
}

export const modifyHref = link => {
  return link?.split(internalLinkPath).join("").replace(".html", "")
}

export const getTrackingUrl = (href, origin = "") => {
  if (!href) return "n/a"

  const normalizedHref = modifyHref(href)
  if (!normalizedHref) return "n/a"

  return `${href.indexOf("http") === -1 ? origin : ""}${normalizedHref}`
}

export const closestAnchorHref = e => {
  return !e.target.closest("a").getAttribute("href")
}

export const pureText = text => {
  return getPureText(text)?.trim()
}

export const pureTextWithoutSpace = text => {
  const pureTextTitle = getPureText(text).trim().toLowerCase()
  return pureTextTitle
    .split(" ")
    .join("-")
    .replace("&amp;-", "")
    .replace("&-", "")
}
